export const SLIDE_AI_TASK_FLAG = 'SLPV-167-slide-plugin-ai-task'
export const SLIDE_AI_FEATURE_SETTING = 'aiContentGeneration'
